import data from "../../.sourceflow/consultant.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const consultant_helper = new CollectionHelper(data);
